<template>
  <div>
    <em v-if="isSecure">{{ $t('jwt') }}</em>
    <ul>
      <li v-for="element in list" :key="element[attr]">{{ element[attr] }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      isSecure: false
    }
  },
  props: {
    array: Array,
    attr: String,
    blacklist: Array
  },
  created () {
    const uniq = {}
    this.list = this.array.filter((element) => {
      const key = element[this.attr]
      if (key === 'jwt' || key === 'jwtauth') {
        this.isSecure = true
        return false
      }
      if (uniq[key] === undefined && !this.blacklist.includes(key)) {
        uniq[key] = key
        return true
      }
      return false
    })
  }
}
</script>

<i18n>
{
  "en": {
    "jwt": "(secured with JWT)"
  }
}
</i18n>
